import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useOrganization } from '../../context/OrganizationContext';
import './Auth.css';

const Login = () => {
  const [formData, setFormData] = useState({
    phone_number: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { organization } = useOrganization();
  const navigate = useNavigate();
  const orgName = organization?.chinese_name || organization?.english_name || organization?.name || 'Hong Kong Synergies';

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData);

    if (result.success) {
      navigate(result.user?.is_staff ? '/admin' : '/member');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="container">
        <div className="auth-card card">
          <div className="auth-brand">
            <img
              src={`${process.env.PUBLIC_URL}/hkslogo-2.png`}
              alt={orgName}
              className="auth-logo"
            />
          </div>
          <h1>會員登入</h1>
          {error && <div className="alert alert-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>電話號碼</label>
              <input
                type="tel"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                placeholder="請輸入電話號碼"
                required
              />
            </div>
            <div className="form-group">
              <label>密碼</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="請輸入密碼"
                required
              />
            </div>
            <button type="submit" className="btn btn-primary btn-large" disabled={loading}>
              {loading ? '登入中...' : '登入'}
            </button>
          </form>
          <div className="auth-footer">
            <p>還未成為會員？ <Link to="/register">立即註冊</Link></p>
            <Link to="/">返回首頁</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
